/**
 * Created by lihanying on 2017/6/29.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { fetchData, postData } from '../../util/index'
import { message } from 'antd'
import { GETCLUBSTREAM, GETCLUBWALLETS } from './constants'

export const getClubStream = (payload) => {
  return {
    type: GETCLUBSTREAM,
    payload,
  }
}
export const getClubWallet = (payload) => {
  return {
    type: GETCLUBWALLETS,
    payload,
  }
}

//钱包流水
export function fetchClubStreamList() {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/WalletApi/WalletClub`
    return fetchData(endpoint).then((data) => {
      dispatch(getClubStream(data))
      return data
    })
  }
}

//俱乐部钱包
export function fetchClubWalletList() {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/SetClubApi/getWalletInfo`
    return fetchData(endpoint).then((data) => {
      dispatch(getClubWallet(data))
      return data
    })
  }
}

//时间搜索
export function fetchClubSearchStream(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/WalletApi/WalletClub`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      dispatch(getClubStream(data))
      return data
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubStream/action.js